import './Editor.scss';
import Component from './Editor.js';
export default Component;